
if (!customElements.get('as-seen-in')) {
  class AsSeenIn extends HTMLElement {
    constructor() {
      super();
      this.mySwiper = new Swiper(this.querySelector(".as-seen-in-mySwiper"), {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 50,
          }
        }
      });
    }
  }

  customElements.define('as-seen-in', AsSeenIn);
}